import BaseService from "../BaseService";

class ChatService extends BaseService {
    getOrCreateThread = async () => {
        return await this._api.post("/store/chat/thread/get_or_create", {});
    };

    listThread = async ({ page = 1, page_size = 20 } = {}) => {
        return await this._api.post("/store/chat/thread/list", { page, page_size });
    };

    listMessages = async ({ thread_id, page = 1, page_size = 80 } = {}) => {
        return await this._api.post("/store/chat/thread/messages", { thread_id, page, page_size });
    };

    sendMessage = async ({ thread_id, content = "", attachments = [] } = {}) => {
        return await this._api.post("/store/chat/thread/send", { thread_id, content, attachments });
    };

    markRead = async ({ thread_id } = {}) => {
        return await this._api.post("/store/chat/thread/mark_read", { thread_id });
    };

    getLinkPreview = async ({ url } = {}) => {
        return await this._api.post("/store/chat/link_preview", { url });
    };
}

export default ChatService;